import { createLocalStorageStateHook } from 'use-local-storage-state';
const useTheme = createLocalStorageStateHook('theme', 'light');

export {
  useTheme
};
